import { useCallback } from 'react';

import { QueryKey } from '@/config/query-client';
import {
  exploreFormDescriptionState,
  exploreFormExampleCompaniesState,
  exploreFormLocationsState,
} from '@/features/explore/explore.state';
import { useNavigateTo } from '@/routes/hooks/use-navigate-to';
import { useQueryClient } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

export const useExploreProgrammaticSubmit = (): ((
  problemDescription: string,
) => void) => {
  const queryClient = useQueryClient();
  const navigateTo = useNavigateTo();
  const setDescription = useSetAtom(exploreFormDescriptionState);
  const resetLocations = useResetAtom(exploreFormLocationsState);
  const resetExampleCompanies = useResetAtom(exploreFormExampleCompaniesState);

  return useCallback(
    (problemDescription: string): void => {
      const trimmed = problemDescription.trim();

      if (!trimmed.length) {
        return;
      }

      queryClient.removeQueries({ queryKey: [QueryKey.ExploreSuggestions] });
      resetLocations();
      resetExampleCompanies();
      setDescription(trimmed);
      navigateTo.exploreResults();
    },
    [
      navigateTo,
      queryClient,
      resetExampleCompanies,
      resetLocations,
      setDescription,
    ],
  );
};
